import script from "./DescriptionView.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionView.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionView.vue?vue&type=style&index=0&id=7d19738a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d19738a"]])

export default __exports__